module.exports = __webpack_public_path__ + "img/home.929faf65.png";